<div class="modal-container-custom">
  <div class="modal-content-custom pmn_style_1" >
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" id="prom-note-data-close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">Promissory Note</h4>
    </div>
    <form autocomplete="off" [formGroup]="promissoryDataForm">
      <div class="modal-body">
        <small>Fill up the details below and Proceed to generate the document.</small>
        <div class="mt-4 dark-section">
          <div class="row">
            <div class="col-md-6">
              <div class="compt-input">
                <label>Serial Number</label>
                <div class="r-value-box">
                  <input type="text" id="prom-note-data-serial-number" formControlName="serial_number"
                    class="form-control block-box">
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="compt-input">
                <label>Place</label>
                <div class="r-value-box">
                  <input type="text" id="prom-note-data-place" formControlName="place" class="form-control block-box">
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-6">
              <div class="compt-input">
                <label>Proof of Stamp Duty Payment</label>
                <app-upload-button id="prom-note-data-stamp-paper" #uploadComp [uploadType]="'KEY'"
                  (fileAsDataURL)="setStampPaperDoc($event)" [fileTypes]="fileTypes">
                </app-upload-button>
              </div>
              <small class="border-bottom" *ngIf="!existingStampPaperDoc">{{uploadComp.fileName || "None uploaded"
                }}</small>
              <a class="border-bottom cursor-pointer" *ngIf="existingStampPaperDoc"
                (click)="showDoc(existingStampPaperDoc.file_url)">{{ existingStampPaperDoc.file_name }}</a>
              <div class="error-text"
                *ngIf="(isFormInvalid || !promissoryDataForm.controls['stamp_paper_doc'].pristine) && promissoryDataForm.controls['stamp_paper_doc'].errors">
                <small [hidden]="!promissoryDataForm.controls['stamp_paper_doc'].errors.required">
                  Proof of stamp duty payment is required.
                </small>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
    <div class="modal-footer modal-footer-custom">
      <button type="button" id="prom-note-data-cancel"
        class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left"
        (click)="activeModal.close()">Cancel</button>
      <button type="submit"
        class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
        id="prom-note-data-generate" (click)="postPromissoryNoteData(promissoryDataForm.value)">Generate</button>
    </div>
  </div>
</div>